import React, { useState } from 'react';
import { X, Shield, FileText, Phone, Mail, ExternalLink, Scale, Lock } from 'lucide-react';
import './GDPRPopup.css';

const GDPRPopup = ({ isOpen, onClose, onAccept }) => {
  const [isAccepted, setIsAccepted] = useState(false);

  const handleAccept = () => {
    if (isAccepted) {
      onAccept();
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="gdpr-overlay">
      <div className="gdpr-popup">
        <div className="gdpr-header">
          <div className="gdpr-title">
            <Shield className="gdpr-icon" size={24} />
            <h2>ΠΟΛΙΤΙΚΗ ΠΡΟΣΤΑΣΙΑΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ</h2>
          </div>
          <button className="gdpr-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="gdpr-content">
          <div className="gdpr-intro">
            <p>
              Ο παρών ιστοχώρος του 424 Γενικού Στρατιωτικού Νοσοκομείου Εκπαιδεύσεως (εφεξής: 424 ΓΣΝΕ ή Νοσοκομείο) αναγνωρίζει και σέβεται το δικαίωμα προστασίας των προσωπικών δεδομένων των χρηστών του διαδικτύου, σύμφωνα με τον Ευρωπαϊκό Κανονισμό 2016/679 και το ν. 4624/2019. Το παρόν κείμενο πολιτικής περιγράφει τη συλλογή και επεξεργασία δεδομένων των χρηστών κατά την επίσκεψη ή χρήση των παρεχόμενων υπηρεσιών του Ιστοχώρου μας. Ο επισκέπτης του Ιστοχώρου μας ή/και χρήστης των υπηρεσιών μας οφείλει να διαβάσει προσεκτικά τους όρους και τις προϋποθέσεις προστασίας των προσωπικών του πληροφοριών που αναφέρονται εδώ, εφόσον δε, εξακολουθεί να κάνει χρήση, σημαίνει ότι τους αποδέχεται και συγκατατίθεται στην επεξεργασία των προσωπικών του δεδομένων από το Νοσοκομείο.
            </p>
          </div>

          <div className="gdpr-section">
            <h3><FileText size={18} /> Υπεύθυνος επεξεργασίας</h3>
            <div className="contact-info">
              <p>Υπεύθυνος επεξεργασίας είναι τo 424 ΓΣΝΕ, το οποίο έχει έδρα στην Περιφερειακή Οδός Ν. Ευκαρπία, Τ.Κ.:56429, Θεσσαλονίκη</p>
              <div className="contact-item">
                <Phone size={16} />
                <span>Τηλέφωνο: 2310381000</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>Email: 424_gsne@army.gr</span>
              </div>
            </div>
          </div>

          <div className="gdpr-section">
            <h3>Υπεύθυνος Προστασίας Δεδομένων (Data Protection Officer):</h3>
            <p>Το Νοσοκομείο έχει ορίσει Υπεύθυνο Προστασίας Δεδομένων, ο οποίος παρακολουθεί τη συμμόρφωσή της με τον Κανονισμό 2016/679 και άλλες διατάξεις σχετικά με την προστασία δεδομένων.</p>
            <p>Τα στοιχεία επικοινωνίας του είναι τα εξής:</p>
            <div className="contact-info">
              <div className="contact-item">
                <Phone size={16} />
                <span>Τηλέφωνο: 2310381040</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>Email: 424-gsne-dpo@army.gr</span>
              </div>
            </div>
          </div>

          <div className="gdpr-section">
            <h3><Scale size={18} /> Νομοθετικό πλαίσιο:</h3>
            <ul className="rights-list">
              <li><strong>Νόμος 4624/2019:</strong> Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα, μέτρα εφαρμογής του Κανονισμού (ΕΕ) 2016/679 του Ευρωπαϊκού Κοινοβουλίου και του Συμβουλίου της 27ης Απριλίου 2016 για την προστασία των φυσικών προσώπων έναντι της επεξεργασίας δεδομένων προσωπικού χαρακτήρα και ενσωμάτωση στην εθνική νομοθεσία της Οδηγίας (ΕΕ) 2016/680 του Ευρωπαϊκού Κοινοβουλίου και του Συμβουλίου της 27ης Απριλίου2016 & άλλες διατάξεις.</li>
              <li><strong>Κανονισμός (Ε.Ε.) 679/2016:</strong> Για την προστασία των φυσικών προσώπων έναντι της επεξεργασίας των δεδομένων προσωπικού χαρακτήρα & για την ελεύθερη κυκλοφορία των δεδομένων αυτών & την κατάργηση της Οδηγίας 95/46/ΕΚ (Γενικός Κανονισμός για την Προστασία Δεδομένων).</li>
              <li><strong>Οδηγία (E.Ε.) 2016/680:</strong> Για την προστασία των φυσικών προσώπων έναντι της επεξεργασίας δεδομένων προσωπικού χαρακτήρα από αρμόδιες αρχές για τους σκοπούς της πρόληψης, διερεύνησης, ανίχνευσης ή δίωξης ποινικών αδικημάτων ή της εκτέλεσης ποινικών κυρώσεων & για την ελεύθερη κυκλοφορία των δεδομένων αυτών & την κατάργηση της απόφασης-πλαίσιο 2008/977/ΔΕΥ του Συμβουλίου.</li>
              <li><strong>Ν. 2472/1997 [Φ.Ε.Κ. 50/10.4.1997, τ. Α']:</strong> Προστασία του ατόμου από την επεξεργασία δεδομένων προσωπικού χαρακτήρα.</li>
              <li><strong>Ν.3418/2005:</strong> Κώδικας Ιατρικής Δεοντολογίας</li>
            </ul>
          </div>

          <div className="gdpr-section">
            <h3><Lock size={18} /> Ασφάλεια δεδομένων</h3>
            <p>
              Για την προστασία των προσωπικών δεδομένων των χρηστών και επισκεπτών του ιστοχώρου μας χρησιμοποιούμε ασφαλή σύνδεση (https://) και μέτρα ασφαλείας δεδομένων για την αποτροπή του κινδύνου απώλειας, κακής χρήσης, μη εξουσιοδοτημένης πρόσβασης και κοινοποίησης των προσωπικών σας πληροφοριών.
            </p>
          </div>

          <div className="gdpr-section">
            <h3>Τα δικαιώματα σας</h3>
            <p>Όσον αφορά την προστασία των δεδομένων προσωπικού χαρακτήρα που σας αφορούν, έχετε τα εξής δικαιώματα:</p>
            <ul className="rights-list">
              <li><strong>Δικαίωμα πρόσβασης,</strong> δηλ. το δικαίωμα να πληροφορηθείτε εάν προσωπικά δεδομένα που σας αφορούν υφίστανται επεξεργασία,</li>
              <li><strong>Δικαίωμα διόρθωσης,</strong> δηλ. το δικαίωμα να απαιτήσετε τη διόρθωση ανακριβών δεδομένων προσωπικού χαρακτήρα,</li>
              <li><strong>Δικαίωμα διαγραφής,</strong> δηλ. το δικαίωμα να ζητήσετε να διαγραφούν τα προσωπικά δεδομένα που σας αφορούν,</li>
              <li><strong>Δικαίωμα περιορισμού της επεξεργασίας</strong> όταν η ακρίβεια των δεδομένων αμφισβητείται, είναι παράνομη ή για άλλους λόγους,</li>
              <li><strong>Δικαίωμα φορητότητας,</strong> δηλ. το δικαίωμα να ζητήσετε να λάβετε τα δεδομένα που σας αφορούν σε δομημένο, κοινώς χρησιμοποιούμενο και αναγνώσιμο από μηχανήματα μορφότυπο, καθώς και να διαβιβασθούν τα εν λόγω δεδομένα σε άλλον υπεύθυνο επεξεργασίας και στ) <strong>δικαίωμα εναντίωσης</strong> στην επεξεργασία των προσωπικών δεδομένων σας, εκτός αν υφίστανται επιτακτικοί και νόμιμοι λόγοι για την επεξεργασία οι οποίοι υπερισχύουν των συμφερόντων, των δικαιωμάτων και των ελευθεριών σας.</li>
            </ul>
          </div>

          <div className="gdpr-section">
            <h3>Χρήσιμοι σύνδεσμοι:</h3>
            <div className="links">
              <a href="https://www.moh.gov.gr/articles/gdpr" target="_blank" rel="noopener noreferrer">
                <ExternalLink size={16} />
                Υπουργείο Υγείας: www.moh.gov.gr/articles/gdpr
              </a>
              <a href="https://ec.europa.eu/info/law/law-topic/data-protection_el" target="_blank" rel="noopener noreferrer">
                <ExternalLink size={16} />
                Ευρωπαϊκή Επιτροπή: https://ec.europa.eu/info/law/law–topic/data–protection_el
              </a>
              <a href="https://www.dpa.gr" target="_blank" rel="noopener noreferrer">
                <ExternalLink size={16} />
                Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα: www.dpa.gr
              </a>
            </div>
          </div>

          <div className="gdpr-consent">
            <label className="consent-checkbox">
              <input
                type="checkbox"
                checked={isAccepted}
                onChange={(e) => setIsAccepted(e.target.checked)}
              />
              <span className="checkmark"></span>
              <span className="consent-text">
                <strong>Συμφωνώ</strong> με την επεξεργασία των προσωπικών μου δεδομένων 
                σύμφωνα με την πολιτική προστασίας δεδομένων του 424 ΓΣΝΕ και 
                <strong> αποδέχομαι τους όρους χρήσης</strong>.
              </span>
            </label>
          </div>
        </div>

        <div className="gdpr-footer">
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
          >
            Ακύρωση
          </button>
          <button 
            className={`btn btn-primary ${!isAccepted ? 'disabled' : ''}`}
            onClick={handleAccept}
            disabled={!isAccepted}
          >
            Συμφωνώ και Συνεχίζω
          </button>
        </div>
      </div>
    </div>
  );
};

export default GDPRPopup;